import { AxiosError } from 'axios'

import { httpClient } from 'shared/lib'
import isAxiosError from 'shared/utils/helpers/isAxiosError'
import consoleMessage from 'shared/utils/helpers/consoleMessage'

export function verifyAuthService(reflinkUuid: string) {
   let errMessage = ''
   return httpClient
      .get<{ verificationMethod: 'SMS' | 'EMAIL' }>(`/client-carts/reflinks/${reflinkUuid}/verify`)
      .then((res) => ({ data: res.data, status: res.status }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CLIENT_CART_REFLINK getSearchData service', errMessage, 'error')
         throw error
      })
}
